export default {
	title: "Citations de sagesse",
	text: "Citation",
	author: "Auteur",
	isActive: "Active",
	create: "Nouvelle citation",
	edit: "Modifier la citation",
	searchPlaceholder: "Rechercher des citations...",
	noData: "Aucune citation enregistrée",
	noDataSubtext: "Ajoutez des citations de sagesse personnalisées pour votre temple",
	confirmDeleteMessage: "Êtes-vous sûr de vouloir supprimer cette citation ? Cette action est irréversible.",
	stats: {
		total: "Total",
		active: "Actives",
	},
	form: {
		text: "Citation",
		author: "Auteur",
	},
	validation: {
		textMaxLength: "La citation doit comporter au maximum 500 caractères",
		authorMaxLength: "L'auteur doit comporter au maximum 150 caractères",
	},
	systemQuotes: "Système",
	customQuotes: "Personnalisées",
	weightHint: "Ajustez la fréquence d'apparition de chaque type de citation sur le tableau de bord",
	messages: {
		createSuccess: "Citation créée avec succès",
		updateSuccess: "Citation mise à jour avec succès",
		deleteSuccess: "Citation supprimée avec succès",
		createError: "Erreur lors de la création de la citation",
		updateError: "Erreur lors de la mise à jour de la citation",
		deleteError: "Erreur lors de la suppression de la citation",
		loadError: "Erreur lors du chargement des citations",
		weightSaved: "Proportion des citations enregistrée",
		weightError: "Erreur lors de l'enregistrement de la proportion",
	},
};
